var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 15
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m2.93.782.707-.707 6.435 6.435-.707.708zM2.929 14.218l6.435-6.435.707.707-6.435 6.435z"
  })));
};
export { SvgArrow as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMSIgaGVpZ2h0PSIxNSIgdmlld0JveD0iMCAwIDExIDE1Ij48dGl0bGU+YXJyb3c8L3RpdGxlPjxyZWN0IHg9IjYiIHk9Ii0wLjkwNCIgd2lkdGg9IjEiIGhlaWdodD0iOS4xMDEiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0wLjY3NCA1LjY2NCkgcm90YXRlKC00NSkiIGZpbGw9IiNmZmYiLz48cmVjdCB4PSIxLjk1IiB5PSIxMC44NTQiIHdpZHRoPSI5LjEwMSIgaGVpZ2h0PSIxIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtNi4xMjUgNy45MjIpIHJvdGF0ZSgtNDUpIiBmaWxsPSIjZmZmIi8+PC9zdmc+";